import { projectDetailsState, systemNotification } from 'state'
import { SettingsTemplate } from 'components/template'

import {
	collaboratorEmailState,
	collaboratorUsernameToRemoveState,
	formErrors,
	handleAddCollaborator,
	handleAddOtherCollaborator,
	handleCloseAddCollaboratorModal,
	handleCloseRemoveCollaboratorModal,
	handleOpenAddCollaboratorModal,
	handleOpenRemoveCollaboratorModal,
	handleRemoveCollaborator,
	isAddCollaboratorButtonDisabled,
	isAddCollaboratorModalOpenState,
	isAddCollaboratorSuccessState,
	isRemoveCollaboratorButtonDisabledState,
	isRemoveCollaboratorModalOpenState,
	rolesState,
	rolSelectedState,
	setCollaboratorEmail,
	setCollaboratorRole
} from './state'

const SettingsPage = () => (
	<SettingsTemplate
		addCollaborator={handleAddCollaborator}
		addOtherCollaborator={handleAddOtherCollaborator}
		closeAddCollaboratorModal={handleCloseAddCollaboratorModal}
		collaboratorEmail={collaboratorEmailState}
		collaborators={projectDetailsState.value!.collaborators}
		collaboratorUsernameToRemove={collaboratorUsernameToRemoveState}
		errorMessageForCreatingCollaboratorModal={
			systemNotification.value?.error?.message
		}
		errorMessageForRemoveCollaboratorModal={
			systemNotification.value?.error?.message
		}
		inputErrors={formErrors}
		isAddCollaboratorButtonDisabled={isAddCollaboratorButtonDisabled.value}
		isAddCollaboratorModalOpen={isAddCollaboratorModalOpenState.value}
		isRemoveCollaboratorButtonDisabled={
			isRemoveCollaboratorButtonDisabledState.value
		}
		isRemoveCollaboratorButtonLoading={
			isRemoveCollaboratorButtonDisabledState.value
		}
		isRemoveCollaboratorModalOpen={isRemoveCollaboratorModalOpenState.value}
		isUserCollaborator={projectDetailsState.value!.isCollaborator}
		onAddCollaboratorModal={handleOpenAddCollaboratorModal}
		onCloseRemoveCollaboratorModal={handleCloseRemoveCollaboratorModal}
		openRemoveCollaboratorModal={handleOpenRemoveCollaboratorModal}
		projectName={projectDetailsState.value!.name}
		removeCollaborator={handleRemoveCollaborator}
		rolesState={rolesState}
		rolSelectedState={rolSelectedState}
		setCollaboratorRole={setCollaboratorRole}
		updateCollaboratorEmail={setCollaboratorEmail}
		wasAddCollaboratorSuccess={isAddCollaboratorSuccessState.value}
	/>
)

export { SettingsPage }
